const Accordion = ({ children }) => {
  return children;
};

export default Accordion;
